import { render } from "./MdArrowLeftIcon.vue?vue&type=template&id=e6c632ca"
import script from "./MdArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./MdArrowLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__